import Modal from '@components/Modal'
import React, { useState } from 'react'
import { FormFieldStack, FormGroup, FormInput, FormLabel } from '@pages/Itinerary/AddEventModal/FormComponents.styles'
import { Button, ButtonGroup } from '@pages/Itinerary/AddEventModal/FormComponents.styles'

interface EditNameModalProps {
	isOpen: boolean
	onClose: () => void
	onSave: (firstName: string, lastName: string) => void
	initialFirstName: string
	initialLastName: string
	isUpdating?: boolean
}

const EditNameModal: React.FC<EditNameModalProps> = ({
	isOpen,
	onClose,
	onSave,
	initialFirstName,
	initialLastName,
	isUpdating = false,
}) => {
	const [firstName, setFirstName] = useState(initialFirstName)
	const [lastName, setLastName] = useState(initialLastName)

	React.useEffect(() => {
		if (isOpen) {
			setFirstName(initialFirstName)
			setLastName(initialLastName)
		}
	}, [isOpen, initialFirstName, initialLastName])

	const handleSave = () => {
		onSave(firstName.trim(), lastName.trim())
	}

	const hasChanges = firstName.trim() !== initialFirstName.trim() || lastName.trim() !== initialLastName.trim()

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Edit Name"
			showCloseButton={true}
			size="medium"
			footer={
				<ButtonGroup $align="right">
					<Button variant="secondary" onClick={onClose} disabled={isUpdating}>
						Cancel
					</Button>
					<Button variant="primary" onClick={handleSave} disabled={!hasChanges || isUpdating}>
						{isUpdating ? 'Saving...' : 'Save Changes'}
					</Button>
				</ButtonGroup>
			}
		>
			<FormFieldStack>
				<FormGroup>
					<FormLabel htmlFor="first-name">First Name</FormLabel>
					<FormInput
						id="first-name"
						type="text"
						value={firstName}
						onChange={e => setFirstName(e.target.value)}
						placeholder="Enter first name"
						autoFocus
					/>
				</FormGroup>

				<FormGroup>
					<FormLabel htmlFor="last-name">Last Name</FormLabel>
					<FormInput
						id="last-name"
						type="text"
						value={lastName}
						onChange={e => setLastName(e.target.value)}
						placeholder="Enter last name"
					/>
				</FormGroup>
			</FormFieldStack>
		</Modal>
	)
}

export default EditNameModal

